import { getBaseSelectors } from '../../../store/shared/dcr-form-submission/form-submission.selectors';
import { featureKey } from '../store/contact-us.reducer';
import { ContactUsPayload } from './types/contact-us.state.type';

export const contactUsSelectors =
  getBaseSelectors<ContactUsPayload>(featureKey);
